import React, { useRef } from 'react';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { Form } from '@unform/web';

import { Container, Subtitle } from './style';

import HeaderLogo from 'assets/logo.svg';
import DefaultInput from 'components/Inputs/DefaultInput/DefaultInput';
import DefaultButton from 'components/Buttons/DefaultButton';
import BackButton from 'components/Buttons/BackButton';
import { FormHandles } from '@unform/core';
import getValidationErrors from 'helpers/getValidationErrors';
import { forgotPassword as forgotPasswordService } from 'services/forgot-password';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('E-mail inválido.')
    .trim()
    .required('Preencha corretamente este campo.'),
});

interface IUserData {
  email: string;
}

const ConfirmData: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const handleSubmit = async (data: IUserData) => {
    const { email } = data;

    try {
      formRef.current?.setErrors({});

      await schema.validate(data, { abortEarly: false });

      await forgotPasswordService(data).then(() => {
        history.push('/forgot-password/reset-password', { email });
      });
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
      }
    }
  };

  return (
    <Container>
      <div className="return-btn">
        <BackButton />
      </div>

      <img src={HeaderLogo} alt="logo" />

      <h3>Redefinir sua senha</h3>

      <Subtitle>
        Para redefinir a senha de sua conta digite seu email cadastrado .
      </Subtitle>

      <Form onSubmit={handleSubmit} ref={formRef}>
        <DefaultInput name="email" type="text" label="E-mail" required />

        <DefaultButton type="submit">Enviar</DefaultButton>
      </Form>
    </Container>
  );
};

export default ConfirmData;
